/**
 * i18n initialization and setup
 */

import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { I18N_CONFIG  } from './config'

// Import translation files
import commonEnUS from './locales/en-US/common.json'
import tasksEnUS from './locales/en-US/tasks.json'
import labelsEnUS from './locales/en-US/labels.json'
import settingsEnUS from './locales/en-US/settings.json'
import navigationEnUS from './locales/en-US/navigation.json'
import validationEnUS from './locales/en-US/validation.json'
import authEnUS from './locales/en-US/auth.json'
import projectsEnUS from './locales/en-US/projects.json'
import notesEnUS from './locales/en-US/notes.json'
import activityEnUS from './locales/en-US/activity.json'
import homeEnUS from './locales/en-US/home.json'
import notificationsEnUS from './locales/en-US/notifications.json'

import commonEnGB from './locales/en-GB/common.json'
import tasksEnGB from './locales/en-GB/tasks.json'
import labelsEnGB from './locales/en-GB/labels.json'
import settingsEnGB from './locales/en-GB/settings.json'
import navigationEnGB from './locales/en-GB/navigation.json'
import validationEnGB from './locales/en-GB/validation.json'
import authEnGB from './locales/en-GB/auth.json'
import projectsEnGB from './locales/en-GB/projects.json'
import notesEnGB from './locales/en-GB/notes.json'
import activityEnGB from './locales/en-GB/activity.json'
import homeEnGB from './locales/en-GB/home.json'
import notificationsEnGB from './locales/en-GB/notifications.json'
import type {SupportedLocale} from './config';

/**
 * Initialize i18next
 */
const initI18n = () => {
  i18next
    .use(initReactI18next)
    .init({
      ...I18N_CONFIG,
      resources: {
        'en': {
          // Fallback for browser 'en' → use en-US
          common: commonEnUS,
          tasks: tasksEnUS,
          labels: labelsEnUS,
          settings: settingsEnUS,
          navigation: navigationEnUS,
          validation: validationEnUS,
          auth: authEnUS,
          projects: projectsEnUS,
          notes: notesEnUS,
          activity: activityEnUS,
          home: homeEnUS,
          notifications: notificationsEnUS,
        },
        'en-US': {
          common: commonEnUS,
          tasks: tasksEnUS,
          labels: labelsEnUS,
          settings: settingsEnUS,
          navigation: navigationEnUS,
          validation: validationEnUS,
          auth: authEnUS,
          projects: projectsEnUS,
          notes: notesEnUS,
          activity: activityEnUS,
          home: homeEnUS,
          notifications: notificationsEnUS,
        },
        'en-GB': {
          common: commonEnGB,
          tasks: tasksEnGB,
          labels: labelsEnGB,
          settings: settingsEnGB,
          navigation: navigationEnGB,
          validation: validationEnGB,
          auth: authEnGB,
          projects: projectsEnGB,
          notes: notesEnGB,
          activity: activityEnGB,
          home: homeEnGB,
          notifications: notificationsEnGB,
        },
      },
    })

  return i18next
}

// Initialize on import
initI18n()

export { i18next as i18n }
export * from './config'

/**
 * Type-safe translation key helper
 */
export type TranslationKey<NS extends string = string> = `${NS}:${string}`

/**
 * Change language programmatically
 */
export const changeLanguage = async (locale: SupportedLocale) => {
  await i18next.changeLanguage(locale)
}

/**
 * Get current language
 */
export const getCurrentLanguage = (): SupportedLocale => {
  return i18next.language as SupportedLocale
}
